// extracted by mini-css-extract-plugin
export default {"root":"Option_root__yYTWD","remove":"Option_remove__n3-tR","body":"Option_body__VOOwy","clickable":"Option_clickable__KvCvp"};